import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['option']

  connect() {
    const defaultOption = this.optionTargets.find(
      (target) => target.dataset.shopifyAirportLocationAirportParam === 'ORD'
    )
    if (defaultOption) {
      this._highlight(defaultOption)
    }
  }

  select({ currentTarget, params: { airport } }) {
    this._highlight(currentTarget)
    this.element.querySelector('[name="shipping_method_print_options[airport_location]"]').value =
      airport
  }

  _highlight(activeOption) {
    this.optionTargets.forEach((target) => {
      target.style.removeProperty('box-shadow')
      target.style.removeProperty('color')
      target.style.removeProperty('font-weight')
    })
    // Solid brand-purple fill + outer ring; high contrast in both light and dark
    // themes (where `var(--dark)` would otherwise blend into the background).
    activeOption.style.boxShadow = 'inset 0 0 0 999px #5452FF, 0 0 0 2px #5452FF'
    activeOption.style.color = 'white'
    activeOption.style.fontWeight = 'bold'
  }
}
